import { useEffect, useState } from "react";
import { oauthClient } from "../apis/OAuthClient";
import { ApiPortalBackend } from "../apis/ApiPortalBackend";
import { PortalUser } from "../types/PortalUser";
import { userEventDispatcher, UserService, userService } from "../dataservices/UserService";


export const useUserHook = () : [user:PortalUser|null, UserService:UserService] => {
    
    const [user, setUser] = useState<PortalUser|null>(null);


    useEffect(() => {
        userService.fetchUser().then(data => {
            setUser(data);
        });

        const handleUserUpdate = () => {
            setUser(userService.getUser());
        };
    
        // Event-Listener für "userUpdate" hinzufügen
        userEventDispatcher.addEventListener('userUpdate', handleUserUpdate);
    
        // Cleanup-Function: Entfernt den Listener beim Unmount
        return () => {
            userEventDispatcher.removeEventListener('userUpdate', handleUserUpdate);
        };

    }, []);

    return [user, userService];
}
